import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import FormOne from '../component/contact/FormOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';
import InfoButton from '../elements/info-button/InfoButton';


const Contact = () => {
    const { language } = useLanguage();

    const ContactAnimation = () => (
        <div className="contact-animation">
            <svg viewBox="0 0 500 300" className="contact-svg">
                {/* Phone */}
                <g className="icon-bounce-1">
                    <rect x="100" y="100" width="40" height="70" rx="5" fill="#3498db"/>
                    <rect x="105" y="105" width="30" height="50" fill="#fff"/>
                    <circle cx="120" cy="162" r="3" fill="#fff"/>
                </g>
                
                {/* Envelope */}
                <g className="icon-bounce-2">
                    <rect x="250" y="80" width="60" height="40" fill="#e74c3c"/>
                    <path d="M250 80 L280 100 L310 80" fill="#c0392b"/>
                </g>
                
                {/* Location Pin */}
                <g className="icon-bounce-3">
                    <path d="M420 100 C409 100 400 109 400 120 C400 135 420 150 420 150 C420 150 440 135 440 120 C440 109 431 100 420 100 Z" fill="#2ecc71"/>
                    <circle cx="420" cy="120" r="8" fill="#fff"/>
                </g>
                
                {/* Connecting Lines */}
                <path d="M140 135 Q 200 160 250 120" stroke="#ccc" strokeWidth="2" strokeDasharray="5,5" fill="none" className="dash-line-1"/>
                <path d="M310 100 Q 360 80 400 125" stroke="#ccc" strokeWidth="2" strokeDasharray="5,5" fill="none" className="dash-line-2"/>
            </svg>
            <style jsx>{`
                .contact-animation {
                    width: 100%;
                    height: 100%;
                    min-height: 250px;
                }
                .icon-bounce-1 {
                    animation: bounce1 2s ease-in-out infinite;
                }
                .icon-bounce-2 {
                    animation: bounce2 2s ease-in-out infinite 0.5s;
                }
                .icon-bounce-3 {
                    animation: bounce3 2s ease-in-out infinite 1s;
                }
                @keyframes bounce1 {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
                @keyframes bounce2 {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
                @keyframes bounce3 {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
                .dash-line-1 {
                    animation: dashDraw 2s linear infinite;
                }
                .dash-line-2 {
                    animation: dashDraw 2s linear infinite reverse;
                }
                @keyframes dashDraw {
                    to { stroke-dashoffset: -20; }
                }
            `}</style>
        </div>
    );

    return (
        <>
            <SEO title={Features.CONTACT.TITLE[language]} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <div className="breadcrum-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="section-heading heading-left">
                                    <h1 className="title h2">{Features.CONTACT.TITLE[language]}</h1>
                                    <p>{Features.CONTACT.SUBTITLE[language]}</p>
                                </div>
                            </div>
                            <div className="col-lg-6 d-none d-lg-block">
                                <ContactAnimation />
                            </div>
                        </div>
                    </div>
                </div>

            <div className="section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6">
                            <div className="contact-form-box shadow-box mb--30">
                                <h3 className="title">{Features.CONTACT.FORM_TITLE[language]}</h3>
                                <FormOne isContactPage={true} />
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 offset-xl-1">
                            <div className="contact-info mb--30">
                                <h4 className="title">{Features.CONTACT.PHONE_TITLE[language]}</h4>
                                <p>{Features.CONTACT.PHONE_DESC[language]}</p>
                                <h4 className="phone-number" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                    <a href="tel:+351914440333">(+351) 914 440 333</a>
                                    <InfoButton />
                                </h4>
                            </div>
                            <div className="contact-info mb--30">
                                <h4 className="title">{Features.CONTACT.EMAIL_TITLE[language]}</h4>
                                <p>{Features.CONTACT.EMAIL_DESC[language]}</p>
                                <h4 className="phone-number"><a href="mailto:geral@fielcarga.pt">geral@fielcarga.pt</a></h4>
                            </div>
                            <div className="contact-info mb--30">
                                <h4 className="title">{Features.CONTACT.ADDRESS_TITLE[language]}</h4>
                                <p>{Features.COMMON.ADDRESS[language]}<br />{Features.COMMON.POSTAL_CODE[language]}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className="list-unstyled shape-group-12">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="Bubble" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Bubble" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="Circle" /></li>
                </ul>
            </div>

            <div className="section section-padding bg-color-dark overflow-hidden">
                <div className="container">
                    <SectionTitle 
                        subtitle={Features.CONTACT.LOCATION_TITLE[language]}
                        title={Features.CONTACT.LOCATION_SUBTITLE[language]}
                        description=""
                        textAlignment="heading-light-left"
                        textColor=""
                    />
                    <div className="row">
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001.626480838661!2d-8.583333!3d41.183333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd24639999999999%3A0x0!2sRua+Dom+Afonso+Henriques+1539%2C+Maia!5e0!3m2!1sen!2spt!4v1600000000000!5m2!1sen!2spt" 
                            width="100%" 
                            height="450" 
                            style={{border:0}} 
                            allowFullScreen="" 
                            loading="lazy"
                            title="Fiel Carga Location"
                        ></iframe>
                    </div>
                </div>
            </div>

            <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
            </main>
        </>
    )
}

export default Contact;